import React, { useEffect, useState } from 'react';
import { withFormik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Form, Label, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import Icon from 'shared/components/Icon';

import styles from './SelectBatchForm.styles';

let SelectBatchFormNew = ({
  billing,
  handleSubmit,
  onSubmit,
  selectedBilling,
  setFieldValue,
  billingDeleteAllPreflight,
  billingDeleteAllCustomers,
  recentlyDeleted,
  isProcessing,
  isLoading
}) => {
  const history = useHistory();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [whichBatch, setWhichBatch] = useState({});

  useEffect(() => {
    setFieldValue('selectedBilling', selectedBilling);
  }, [selectedBilling, setFieldValue]);

  if (!billing.length) return null;

  const openModal = batch => {
    setIsOpen(true);
    setWhichBatch(batch);
  };

  const closeModal = () => {
    setIsOpen(false);
    setWhichBatch({});
  };

  const preflightBatch = () => {
    billingDeleteAllPreflight(whichBatch.id);
    closeModal();
  };

  function replaceLastPathSegment(newId, location) {
    const pathSegments = location.pathname.split('/');

    if (pathSegments.length === 0) return;

    if (newId) {
      pathSegments[pathSegments.length - 1] = newId;
    } else {
      pathSegments.pop();
      setFieldValue('selectedBilling', null);
    }
    const newPath = pathSegments.join('/');
    return newPath;
  }

  const deleteBatch = () => {
    if (!whichBatch.isFinalized) {
      const earliestBatch = billing?.find(batch => batch.id !== whichBatch.id);
      const redirectPath = replaceLastPathSegment(earliestBatch?.id, location);
      billingDeleteAllCustomers(whichBatch.id, whichBatch.name);
      history.push(redirectPath);
      closeModal();
    }
  };

  const showDeleteButton = batch => {
    return !(
      isProcessing ||
      batch.isFinalized ||
      batch.isGenerated ||
      recentlyDeleted.includes(batch.id) ||
      isLoading.status
    );
  };

  return (
    <div css={styles}>
      <hr />
      <div className="pl-4 pr-4">
        <h5>
          <strong>Batch</strong>
        </h5>

        <div className="select-batch-form mb-2">
          <Form autoComplete="nope" onSubmit={handleSubmit}>
            {billing
              .filter(b => !recentlyDeleted.includes(b.id))
              .map(batch => {
                const description = batch.createdBy ? `${batch.createdAt}, ${batch.createdBy}` : `${batch.createdAt}`;
                return (
                  <div className="batch-list-item" key={batch.id}>
                    <div className="form-check input-wrap mb-2">
                      <Input
                        checked={batch.id === selectedBilling}
                        className="form-check-input"
                        id={`selectedBilling-${batch.id}`}
                        name="selectedBilling"
                        onChange={() => onSubmit(batch.id)}
                        placeholder="Selected Batch"
                        type="radio"
                      />
                      <Label
                        className="form-check-label"
                        style={{ fontWeight: '600' }}
                        for={`selectedBilling-${batch.id}`}
                      >
                        {batch.name}
                      </Label>
                      <p style={{ fontSize: '14px', color: '#747377' }}>{description}</p>
                    </div>
                    {showDeleteButton(batch) && (
                      <div onClick={() => openModal(batch)}>
                        <Icon className="trash-can" icon="delete" />
                      </div>
                    )}
                  </div>
                );
              })}
          </Form>
        </div>
      </div>

      <Modal isOpen={isOpen}>
        <ModalHeader>Delete batch {whichBatch.name}?</ModalHeader>
        <ModalBody>All non-finalized invoices in the batch will be deleted.</ModalBody>
        <ModalFooter>
          <Button color="link" onClick={closeModal}>
            Cancel
          </Button>
          <Button onClick={preflightBatch}>No, Just Run Preflight Check</Button>
          <Button onClick={deleteBatch}>Yes, Delete</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

SelectBatchFormNew = withFormik({
  mapPropsToValues: ({ selectedBilling }) => ({
    selectedBilling
  })
})(SelectBatchFormNew);

export default SelectBatchFormNew;
